"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _commonPricings = require("./commonPricings");
var _sofaCreation = require("./sofaCreation");
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
// *** Version: 9 ***

/* eslint max-len: 0, object-curly-newline: 0 */
var rawPricing = [{
  name: 'Manteau & veste',
  slug: 'mant',
  types: undefined,
  hasMostCommonCategory: true,
  showInPlugin: true,
  categories: [{
    name: 'Cintrer',
    slug: 'cin_alteration',
    showInPlugin: true,
    items: [{
      name: 'Épaules (x2)',
      prices: {
        DEFAULT: 47
      },
      liningPrices: {
        DEFAULT: 15
      },
      showInPlugin: true,
      id: '9.mant-cin-1'
    }, {
      name: 'Manches (x2)',
      prices: {
        DEFAULT: 59
      },
      showInPlugin: true,
      id: '9.mant-cin-2'
    }, {
      name: 'Taille',
      prices: {
        DEFAULT: 37
      },
      liningPrices: {
        DEFAULT: 13
      },
      showInPlugin: true,
      id: '9.mant-cin-3'
    }, {
      name: 'Dos',
      prices: {
        DEFAULT: 20
      },
      liningPrices: {
        DEFAULT: 7
      },
      showInPlugin: true,
      id: '9.mant-cin-4',
      mostCommonCategoryPosition: 2,
      mostCommonCategoryLabel: 'Cintrer dos'
    }]
  }, {
    name: 'Élargir',
    slug: 'ela_alteration',
    showInPlugin: true,
    items: [{
      name: 'Épaules (x2)',
      prices: {
        DEFAULT: 52
      },
      liningPrices: {
        DEFAULT: 18
      },
      showInPlugin: true,
      id: '9.mant-ela-1'
    }, {
      name: 'Manches (x2)',
      prices: {
        DEFAULT: 64
      },
      showInPlugin: true,
      id: '9.mant-ela-2'
    }, {
      name: 'Taille',
      prices: {
        DEFAULT: 46
      },
      liningPrices: {
        DEFAULT: 15
      },
      showInPlugin: true,
      id: '9.mant-ela-3'
    }, {
      name: 'Dos',
      prices: {
        DEFAULT: 25
      },
      liningPrices: {
        DEFAULT: 8
      },
      showInPlugin: true,
      id: '9.mant-ela-4'
    }]
  }, {
    name: 'Raccourcir',
    slug: 'rac_alteration',
    showInPlugin: true,
    items: [{
      name: 'Longueur',
      prices: {
        DEFAULT: 29
      },
      liningPrices: {
        DEFAULT: 12
      },
      showInPlugin: true,
      id: '9.mant-rac-1',
      mostCommonCategoryPosition: 1,
      mostCommonCategoryLabel: 'Raccourcir longueur'
    }, {
      name: 'Manche (x2 - par le bas)',
      prices: {
        DEFAULT: 25
      },
      liningPrices: {
        DEFAULT: 5
      },
      id: '9.mant-rac-2'
    }, {
      name: 'Manche (x2 - par l’épaule)',
      prices: {
        DEFAULT: 65
      },
      liningPrices: {
        DEFAULT: 15
      },
      showInPlugin: true,
      id: '9.mant-rac-3'
    }]
  }, {
    name: 'Rallonger',
    slug: 'ral_alteration',
    showInPlugin: true,
    items: [{
      name: 'Longueur',
      prices: {
        DEFAULT: 35
      },
      liningPrices: {
        DEFAULT: 12
      },
      showInPlugin: true,
      id: '9.mant-ral-1'
    }, {
      name: 'Manche (x2 - par le bas)',
      prices: {
        DEFAULT: 27
      },
      liningPrices: {
        DEFAULT: 25
      },
      id: '9.mant-ral-2'
    }, {
      name: 'Manche (x2 - par l’épaule)',
      prices: {
        DEFAULT: 85
      },
      liningPrices: {
        DEFAULT: 25
      },
      showInPlugin: true,
      id: '9.mant-ral-3'
    }]
  }, {
    name: 'Déchirures / trous',
    slug: 'tear_repair',
    showInPlugin: true,
    items: [{
      name: 'Déchirure : réparation',
      prices: {
        DEFAULT: 12
      },
      id: '9.mant-tear-1',
      multiple: true,
      repairBonus: 'HOLE'
    }, {
      name: 'Couture complexe avec empiècement',
      prices: {
        DEFAULT: 17
      },
      id: '9.mant-tear-2',
      multiple: true,
      repairBonus: 'HOLE'
    }, {
      name: 'Couture complexe - 2 empiècements identiques (fourni par client)',
      prices: {
        DEFAULT: 25
      },
      id: '9.mant-tear-3',
      multiple: true,
      hidden: true
    }, {
      name: 'Trou : raccommodage simple',
      prices: {
        DEFAULT: 12
      },
      id: '9.mant-tear-4',
      multiple: true,
      repairBonus: 'UNTIED_UNLINED'
    }]
  }, {
    name: 'Zips',
    slug: 'zip_repair',
    showInPlugin: true,
    items: [{
      name: 'Zip court (< 25cm) fourni par le Tilliste : ajout / remplacement / retrait',
      prices: {
        DEFAULT: 22
      },
      liningPrices: {
        DEFAULT: 5
      },
      id: '9.mant-zip-1',
      multiple: true,
      repairBonus: 'ZIP_SMALL'
    }, {
      name: 'Zip moyen (25-40cm) fourni par le Tilliste : ajout / remplacement / retrait',
      prices: {
        DEFAULT: 37
      },
      liningPrices: {
        DEFAULT: 5
      },
      id: '9.mant-zip-2',
      multiple: true,
      repairBonus: 'ZIP_BIG'
    }, {
      name: 'Zip long (40-80cm) fourni par le Tilliste : ajout / remplacement / retrait',
      prices: {
        DEFAULT: 45
      },
      liningPrices: {
        DEFAULT: 5
      },
      id: '9.mant-zip-3',
      multiple: true,
      repairBonus: 'ZIP_BIG'
    }, {
      name: 'Zip invisible court (< 25cm) fourni par le Tilliste : ajout / remplacement / retrait',
      prices: {
        DEFAULT: 26
      },
      liningPrices: {
        DEFAULT: 5
      },
      id: '9.mant-zip-4',
      multiple: true,
      repairBonus: 'ZIP_SMALL'
    }, {
      name: 'Zip invisible long (40-80cm) fourni par le Tilliste : ajout / remplacement / retrait',
      prices: {
        DEFAULT: 53
      },
      liningPrices: {
        DEFAULT: 5
      },
      id: '9.mant-zip-5',
      multiple: true,
      repairBonus: 'ZIP_BIG'
    }, {
      name: 'Zip court (< 25cm) fourni par le client : ajout / remplacement / retrait',
      prices: {
        DEFAULT: 19
      },
      liningPrices: {
        DEFAULT: 5
      },
      id: '9.mant-zip-6',
      multiple: true,
      repairBonus: 'ZIP_SMALL'
    }, {
      name: 'Zip long (40-80cm) fourni par le client : ajout / remplacement / retrait',
      prices: {
        DEFAULT: 40
      },
      liningPrices: {
        DEFAULT: 5
      },
      id: '9.mant-zip-7',
      multiple: true,
      repairBonus: 'ZIP_BIG'
    }, {
      name: 'Zip invisible court (< 25cm) fourni par le client : ajout / remplacement / retrait',
      prices: {
        DEFAULT: 23
      },
      liningPrices: {
        DEFAULT: 5
      },
      id: '9.mant-zip-8',
      multiple: true,
      repairBonus: 'ZIP_SMALL'
    }, {
      name: 'Zip invisible long (40-80cm) fourni par le client : ajout / remplacement / retrait',
      prices: {
        DEFAULT: 48
      },
      liningPrices: {
        DEFAULT: 5
      },
      id: '9.mant-zip-9',
      multiple: true,
      repairBonus: 'ZIP_BIG'
    }, {
      name: 'Zip invisible moyen (25-40cm) fourni par le Tilliste : ajout / remplacement / retrait',
      prices: {
        DEFAULT: 46
      },
      liningPrices: {
        DEFAULT: 5
      },
      id: '9.mant-zip-10',
      multiple: true,
      repairBonus: 'ZIP_BIG'
    }, {
      name: 'Zip moyen (25-40cm) fourni par le client : ajout / remplacement / retrait',
      prices: {
        DEFAULT: 35
      },
      liningPrices: {
        DEFAULT: 5
      },
      id: '9.mant-zip-11',
      multiple: true,
      repairBonus: 'ZIP_BIG'
    }, {
      name: 'Zip invisible moyen (25-40cm) fourni par le client : ajout / remplacement / retrait',
      prices: {
        DEFAULT: 42
      },
      liningPrices: {
        DEFAULT: 5
      },
      id: '9.mant-zip-12',
      multiple: true,
      repairBonus: 'ZIP_BIG'
    }]
  }, {
    name: 'Boutons',
    slug: 'but_repair',
    showInPlugin: true,
    items: [{
      name: 'Boutonnière (x1) : création',
      prices: {
        DEFAULT: 4
      },
      liningPrices: {
        DEFAULT: 1
      },
      id: '9.mant-but-1',
      multiple: true
    }, {
      name: 'Bouton (x1) fourni par le Tilliste : ajout / remplacement',
      prices: {
        DEFAULT: 3
      },
      id: '9.mant-but-2',
      multiple: true
    }, {
      name: 'Bouton pression (x1) fourni par le client : ajout / remplacement',
      prices: {
        DEFAULT: 8
      },
      id: '9.mant-but-3',
      multiple: true
    }, {
      name: 'Bouton (x1) fourni par le client : ajout / remplacement',
      prices: {
        DEFAULT: 2
      },
      id: '9.mant-but-4',
      multiple: true
    }, {
      name: 'Bouton pression à coudre (x1) fourni par le Tilliste : ajout / remplacement',
      prices: {
        DEFAULT: 3
      },
      id: '9.mant-but-5',
      multiple: true
    }, {
      name: 'Bouton pression à coudre (x1) fourni par le client : ajout / remplacement',
      prices: {
        DEFAULT: 2
      },
      id: '9.mant-but-6',
      multiple: true
    }, {
      name: 'Bouton pression - Jersey, Anorak & Sport Camping (x1) fourni par le Tilliste : ajout / remplacement',
      prices: {
        DEFAULT: 8
      },
      id: '9.mant-but-7',
      multiple: true
    }, {
      name: 'Bouton pression - Jersey, Anorak & Sport Camping (x1) fourni par le client : ajout / remplacement',
      prices: {
        DEFAULT: 6
      },
      id: '9.mant-but-8',
      multiple: true
    }]
  }, {
    name: 'Broderie machine',
    slug: 'machine_embroidery',
    showInPlugin: true,
    items: [{
      name: 'Texte (15 lettres maximum) ≤ 0.5cm',
      prices: {
        DEFAULT: 12
      },
      id: '9.mant-bro-15',
      multiple: true
    }, {
      name: 'Texte (15 lettres maximum) ≤ 2cm',
      prices: {
        DEFAULT: 15
      },
      id: '9.mant-bro-16',
      multiple: true
    }, {
      name: 'Texte (15 lettres maximum) ≤ 3cm',
      prices: {
        DEFAULT: 20
      },
      id: '9.mant-bro-17',
      multiple: true
    }, {
      name: 'Dessin creux ≤ 0.5cm',
      prices: {
        DEFAULT: 12
      },
      id: '9.mant-bro-18',
      multiple: true
    }, {
      name: 'Dessin creux ≤ 2cm',
      prices: {
        DEFAULT: 15
      },
      id: '9.mant-bro-19',
      multiple: true
    }, {
      name: 'Dessin creux ≤ 3cm',
      prices: {
        DEFAULT: 20
      },
      id: '9.mant-bro-20',
      multiple: true
    }]
  }, (0, _commonPricings.getEmbroideryPricingsCategory)('mant', 'SIMPLE'), (0, _commonPricings.getVariousPricingsCategory)({
    pieceSlug: 'mant',
    type: 'COMPLEX'
  })]
}, {
  name: 'Haut',
  slug: 'haut',
  hasMostCommonCategory: true,
  showInPlugin: true,
  types: [{
    slug: 'SIMPLE',
    name: 'Basique'
  }, {
    slug: 'COMPLEX',
    name: 'Habillé'
  }],
  categories: [{
    name: 'Cintrer',
    slug: 'cin_alteration',
    showInPlugin: true,
    items: [{
      name: 'Épaules (x2)',
      prices: {
        SIMPLE: 14,
        COMPLEX: 29
      },
      showInPlugin: true,
      id: '9.haut-cin-1'
    }, {
      name: 'Manches (x2)',
      prices: {
        SIMPLE: 14,
        COMPLEX: 29
      },
      showInPlugin: true,
      id: '9.haut-cin-2'
    }, {
      name: 'Taille',
      prices: {
        SIMPLE: 14,
        COMPLEX: 25
      },
      showInPlugin: true,
      id: '9.haut-cin-3'
    }, {
      name: 'Dos',
      type: 'SIMPLE',
      prices: {
        SIMPLE: 9,
        COMPLEX: 18
      },
      showInPlugin: true,
      id: '9.haut-cin-4',
      mostCommonCategoryPosition: 5,
      mostCommonCategoryLabel: 'Cintrer dos'
    }]
  }, {
    name: 'Élargir',
    slug: 'ela_alteration',
    showInPlugin: true,
    items: [{
      name: 'Épaules (x2)',
      prices: {
        SIMPLE: 15,
        COMPLEX: 28
      },
      showInPlugin: true,
      id: '9.haut-ela-1'
    }, {
      name: 'Manches (x2)',
      prices: {
        SIMPLE: 15,
        COMPLEX: 32
      },
      showInPlugin: true,
      id: '9.haut-ela-2'
    }, {
      name: 'Taille',
      prices: {
        SIMPLE: 15,
        COMPLEX: 32
      },
      showInPlugin: true,
      id: '9.haut-ela-3'
    }, {
      name: 'Dos',
      prices: {
        SIMPLE: 10,
        COMPLEX: 20
      },
      showInPlugin: true,
      id: '9.haut-ela-4'
    }]
  }, {
    name: 'Raccourcir',
    slug: 'rac_alteration',
    showInPlugin: true,
    items: [{
      name: 'Longueur',
      prices: {
        SIMPLE: 8,
        COMPLEX: 21
      },
      showInPlugin: true,
      id: '9.haut-rac-1',
      mostCommonCategoryPosition: 4,
      mostCommonCategoryLabel: 'Raccourcir longueur'
    }, {
      name: 'Manches (x2 - par le bas)',
      prices: {
        SIMPLE: 10,
        COMPLEX: 23
      },
      showInPlugin: true,
      id: '9.haut-rac-2'
    }, {
      name: 'Manches (x2 - par l’épaule)',
      prices: {
        SIMPLE: 28,
        COMPLEX: 65
      },
      id: '9.haut-rac-3'
    }, {
      name: 'Bretelles (x2 - par l’épaule)',
      prices: {
        SIMPLE: 8,
        COMPLEX: 18
      },
      id: '9.haut-rac-7'
    }]
  }, {
    name: 'Rallonger',
    slug: 'ral_alteration',
    showInPlugin: true,
    items: [{
      name: 'Longueur',
      prices: {
        SIMPLE: 10,
        COMPLEX: 24
      },
      showInPlugin: true,
      id: '9.haut-ral-1'
    }, {
      name: 'Manches (x2 - par le bas)',
      prices: {
        SIMPLE: 12,
        COMPLEX: 27
      },
      showInPlugin: true,
      id: '9.haut-ral-2'
    }, {
      name: 'Manches (x2 - par l’épaule)',
      prices: {
        SIMPLE: 30,
        COMPLEX: 75
      },
      id: '9.haut-ral-3'
    }]
  }, (0, _commonPricings.getCommunTear)({
    slug: 'haut',
    isSuitableForJunior: true
  }), (0, _commonPricings.getCommunZips)({
    slug: 'haut',
    isSuitableForJunior: true
  }), (0, _commonPricings.getCommunButtons)({
    slug: 'haut',
    isSuitableForJunior: true
  }), (0, _commonPricings.getEmbroideryPricingsCategory)('haut'), (0, _commonPricings.getCommunMachineEmbroidery)({
    slug: 'haut'
  }), (0, _commonPricings.getVariousPricingsCategory)({
    pieceSlug: 'haut',
    isSuitableForJunior: true
  })]
}, {
  name: 'Pantalon',
  slug: 'pant',
  hasMostCommonCategory: true,
  showInPlugin: true,
  types: [{
    slug: 'SIMPLE',
    name: 'Basique'
  }, {
    slug: 'COMPLEX',
    name: 'Habillé'
  }],
  categories: [{
    name: 'Cintrer',
    slug: 'cin_alteration',
    showInPlugin: true,
    items: [{
      name: 'Ceinture',
      prices: {
        SIMPLE: 42,
        COMPLEX: 32
      },
      liningPrices: {
        COMPLEX: 11
      },
      showInPlugin: true,
      id: '9.pant-cin-1'
    }, {
      name: 'Jambes (x2)',
      prices: {
        SIMPLE: 42,
        COMPLEX: 45
      },
      liningPrices: {
        COMPLEX: 9
      },
      showInPlugin: true,
      id: '9.pant-cin-2'
    }, {
      name: 'Bas de jambes (x2)',
      prices: {
        SIMPLE: 22,
        COMPLEX: 24
      },
      liningPrices: {
        COMPLEX: 8
      },
      showInPlugin: true,
      id: '9.pant-cin-3',
      mostCommonCategoryPosition: 5,
      mostCommonCategoryLabel: 'Cintrer bas de jambes'
    }, {
      name: 'Entrejambe',
      prices: {
        SIMPLE: 15,
        COMPLEX: 22
      },
      liningPrices: {
        COMPLEX: 9
      },
      showInPlugin: true,
      id: '9.pant-cin-4'
    }]
  }, {
    name: 'Élargir',
    slug: 'ela_alteration',
    showInPlugin: true,
    items: [{
      name: 'Ceinture',
      prices: {
        SIMPLE: 47,
        COMPLEX: 38
      },
      liningPrices: {
        COMPLEX: 12
      },
      showInPlugin: true,
      id: '9.pant-ela-1'
    }, {
      name: 'Jambes (x2)',
      prices: {
        SIMPLE: 47,
        COMPLEX: 50
      },
      liningPrices: {
        COMPLEX: 10
      },
      showInPlugin: true,
      id: '9.pant-ela-2'
    }, {
      name: 'Bas de jambes (x2)',
      prices: {
        SIMPLE: 27,
        COMPLEX: 27
      },
      liningPrices: {
        COMPLEX: 9
      },
      showInPlugin: true,
      id: '9.pant-ela-3'
    }, {
      name: 'Entrejambe',
      prices: {
        SIMPLE: 20,
        COMPLEX: 27
      },
      liningPrices: {
        COMPLEX: 10
      },
      showInPlugin: true,
      id: '9.pant-ela-4'
    }]
  }, {
    name: 'Ourlets',
    slug: 'hem_alteration',
    showInPlugin: true,
    items: [{
      name: 'Ourlet simple (x2)',
      isSuitableForJunior: true,
      prices: {
        SIMPLE: 12,
        COMPLEX: 17
      },
      liningPrices: {
        COMPLEX: 7
      },
      showInPlugin: true,
      id: '9.pant-rac-1',
      mostCommonCategoryPosition: 1
    }, {
      name: 'Ourlet revers (x2)',
      isSuitableForJunior: true,
      prices: {
        SIMPLE: 15,
        COMPLEX: 20
      },
      liningPrices: {
        COMPLEX: 9
      },
      showInPlugin: true,
      id: '9.pant-rac-2'
    }]
  }, {
    name: 'Rallonger',
    slug: 'ral_alteration',
    showInPlugin: true,
    items: [{
      name: 'Jambes (x2)',
      prices: {
        SIMPLE: 15,
        COMPLEX: 20
      },
      liningPrices: {
        COMPLEX: 9
      },
      showInPlugin: true,
      id: '9.pant-ral-1'
    }, {
      name: 'Ourlet (x2) : suppression des revers',
      prices: {
        COMPLEX: 17
      },
      liningPrices: {
        COMPLEX: 7
      },
      showInPlugin: true,
      id: '9.pant-ral-2'
    }]
  }, (0, _commonPricings.getCommunTear)({
    slug: 'pant',
    isSuitableForJunior: true
  }), (0, _commonPricings.getCommunZips)({
    slug: 'pant',
    isSuitableForJunior: true
  }), (0, _commonPricings.getCommunButtons)({
    slug: 'pant',
    isSuitableForJunior: true
  }), (0, _commonPricings.getEmbroideryPricingsCategory)('pant'), (0, _commonPricings.getCommunMachineEmbroidery)({
    slug: 'pant'
  }), (0, _commonPricings.getVariousPricingsCategory)({
    pieceSlug: 'pant',
    isSuitableForJunior: true
  })]
}, {
  name: 'Jupe',
  slug: 'jupe',
  hasMostCommonCategory: true,
  showInPlugin: true,
  types: [{
    slug: 'SIMPLE',
    name: 'Basique'
  }, {
    slug: 'COMPLEX',
    name: 'Habillée'
  }],
  categories: [{
    name: 'Cintrer',
    slug: 'cin_alteration',
    showInPlugin: true,
    items: [{
      name: 'Côtés (x2)',
      prices: {
        SIMPLE: 20,
        COMPLEX: 23
      },
      liningPrices: {
        SIMPLE: 4,
        COMPLEX: 5
      },
      showInPlugin: true,
      id: '9.jupe-cin-2'
    }, {
      name: 'Taille / ceinture',
      prices: {
        SIMPLE: 27,
        COMPLEX: 33
      },
      liningPrices: {
        SIMPLE: 3,
        COMPLEX: 5
      },
      showInPlugin: true,
      id: '9.jupe-cin-1',
      mostCommonCategoryPosition: 5
    }]
  }, {
    name: 'Élargir',
    slug: 'ela_alteration',
    showInPlugin: true,
    items: [{
      name: 'Côtés (x2)',
      prices: {
        SIMPLE: 22,
        COMPLEX: 25
      },
      liningPrices: {
        SIMPLE: 5,
        COMPLEX: 6
      },
      showInPlugin: true,
      id: '9.jupe-ela-1'
    }, {
      name: 'Taille / ceinture',
      prices: {
        SIMPLE: 29,
        COMPLEX: 35
      },
      liningPrices: {
        SIMPLE: 5,
        COMPLEX: 6
      },
      showInPlugin: true,
      id: '9.jupe-ela-2'
    }]
  }, {
    name: 'Raccourcir',
    slug: 'rac_alteration',
    showInPlugin: true,
    items: [{
      name: 'Ourlet simple',
      isSuitableForJunior: true,
      prices: {
        SIMPLE: 12,
        COMPLEX: 20
      },
      liningPrices: {
        SIMPLE: 4,
        COMPLEX: 4
      },
      showInPlugin: true,
      id: '9.jupe-rac-1',
      mostCommonCategoryPosition: 1
    }, {
      name: 'Ourlet ample',
      isSuitableForJunior: true,
      prices: {
        SIMPLE: 18,
        COMPLEX: 23
      },
      liningPrices: {
        SIMPLE: 4,
        COMPLEX: 5
      },
      showInPlugin: true,
      id: '9.jupe-rac-2'
    }, {
      name: 'Ourlet à volants',
      isSuitableForJunior: true,
      prices: {
        SIMPLE: 22,
        COMPLEX: 28
      },
      liningPrices: {
        SIMPLE: 5,
        COMPLEX: 6
      },
      showInPlugin: true,
      id: '9.jupe-rac-3'
    }]
  }, {
    name: 'Rallonger',
    slug: 'ral_alteration',
    showInPlugin: true,
    items: [{
      name: 'Longueur simple',
      prices: {
        SIMPLE: 15,
        COMPLEX: 20
      },
      liningPrices: {
        SIMPLE: 4,
        COMPLEX: 4
      },
      showInPlugin: true,
      id: '9.jupe-ral-1'
    }, {
      name: 'Longueur ample',
      prices: {
        SIMPLE: 20,
        COMPLEX: 23
      },
      liningPrices: {
        SIMPLE: 4,
        COMPLEX: 5
      },
      showInPlugin: true,
      id: '9.jupe-ral-2'
    }, {
      name: 'Longueur à volants',
      prices: {
        SIMPLE: 22,
        COMPLEX: 30
      },
      liningPrices: {
        SIMPLE: 5,
        COMPLEX: 5
      },
      showInPlugin: true,
      id: '9.jupe-ral-3'
    }]
  }, (0, _commonPricings.getCommunTear)({
    slug: 'jupe',
    isSuitableForJunior: true
  }), (0, _commonPricings.getCommunZips)({
    slug: 'jupe',
    isSuitableForJunior: true
  }), (0, _commonPricings.getCommunButtons)({
    slug: 'jupe',
    isSuitableForJunior: true
  }), (0, _commonPricings.getEmbroideryPricingsCategory)('jupe'), (0, _commonPricings.getVariousPricingsCategory)({
    pieceSlug: 'jupe',
    isSuitableForJunior: true
  })]
}, {
  name: 'Robe',
  slug: 'robe',
  hasMostCommonCategory: true,
  showInPlugin: true,
  types: [{
    slug: 'SIMPLE',
    name: 'Basique'
  }, {
    slug: 'COMPLEX',
    name: 'Habillée'
  }],
  categories: [{
    name: 'Cintrer',
    slug: 'cin_alteration',
    showInPlugin: true,
    items: [{
      name: 'Côtés (x2)',
      prices: {
        SIMPLE: 20,
        COMPLEX: 23
      },
      liningPrices: {
        SIMPLE: 4,
        COMPLEX: 5
      },
      showInPlugin: true,
      id: '9.robe-cin-1'
    }, {
      name: 'Épaules (x2)',
      prices: {
        SIMPLE: 22,
        COMPLEX: 24
      },
      liningPrices: {
        SIMPLE: 3,
        COMPLEX: 4
      },
      showInPlugin: true,
      id: '9.robe-cin-2'
    }, {
      name: 'Manches (x2 - sans boutonnière)',
      prices: {
        SIMPLE: 20,
        COMPLEX: 27
      },
      showInPlugin: true,
      id: '9.robe-cin-3'
    }, {
      name: 'Manches (x2 - boutonnière)',
      prices: {
        SIMPLE: 32,
        COMPLEX: 34
      },
      showInPlugin: true,
      id: '9.robe-cin-4'
    }, {
      name: 'Bustier / taille',
      prices: {
        SIMPLE: 25,
        COMPLEX: 33
      },
      liningPrices: {
        SIMPLE: 3,
        COMPLEX: 5
      },
      showInPlugin: true,
      id: '9.robe-cin-5',
      mostCommonCategoryPosition: 5,
      mostCommonCategoryLabel: 'Cintrer taille'
    }, {
      name: 'Dos',
      prices: {
        SIMPLE: 21,
        COMPLEX: 24
      },
      liningPrices: {
        SIMPLE: 4,
        COMPLEX: 5
      },
      showInPlugin: true,
      id: '9.robe-cin-6'
    }]
  }, {
    name: 'Élargir',
    slug: 'ela_alteration',
    showInPlugin: true,
    items: [{
      name: 'Côtés (x2)',
      prices: {
        SIMPLE: 23,
        COMPLEX: 26
      },
      liningPrices: {
        SIMPLE: 6,
        COMPLEX: 6
      },
      showInPlugin: true,
      id: '9.robe-ela-1'
    }, {
      name: 'Épaules (x2)',
      prices: {
        SIMPLE: 25,
        COMPLEX: 30
      },
      liningPrices: {
        SIMPLE: 4,
        COMPLEX: 5
      },
      showInPlugin: true,
      id: '9.robe-ela-2'
    }, {
      name: 'Manches (x2 - sans boutonnière)',
      prices: {
        SIMPLE: 25,
        COMPLEX: 29
      },
      showInPlugin: true,
      id: '9.robe-ela-3'
    }, {
      name: 'Manches (x2 - boutonnière)',
      prices: {
        SIMPLE: 35,
        COMPLEX: 38
      },
      showInPlugin: true,
      id: '9.robe-ela-4'
    }, {
      name: 'Bustier / taille',
      prices: {
        SIMPLE: 27,
        COMPLEX: 35
      },
      liningPrices: {
        SIMPLE: 3,
        COMPLEX: 5
      },
      showInPlugin: true,
      id: '9.robe-ela-5'
    }, {
      name: 'Dos',
      prices: {
        SIMPLE: 26,
        COMPLEX: 27
      },
      liningPrices: {
        SIMPLE: 5,
        COMPLEX: 6
      },
      showInPlugin: true,
      id: '9.robe-ela-6'
    }]
  }, {
    name: 'Raccourcir',
    slug: 'rac_alteration',
    showInPlugin: true,
    items: [{
      name: 'Ourlet simple',
      isSuitableForJunior: true,
      prices: {
        SIMPLE: 12,
        COMPLEX: 20
      },
      liningPrices: {
        SIMPLE: 4,
        COMPLEX: 4
      },
      showInPlugin: true,
      id: '9.robe-rac-1',
      mostCommonCategoryPosition: 1
    }, {
      name: 'Ourlet ample',
      isSuitableForJunior: true,
      prices: {
        SIMPLE: 18,
        COMPLEX: 23
      },
      liningPrices: {
        SIMPLE: 4,
        COMPLEX: 5
      },
      showInPlugin: true,
      id: '9.robe-rac-2'
    }, {
      name: 'Ourlet à volants',
      isSuitableForJunior: true,
      prices: {
        SIMPLE: 22,
        COMPLEX: 28
      },
      liningPrices: {
        SIMPLE: 5,
        COMPLEX: 6
      },
      showInPlugin: true,
      id: '9.robe-rac-3'
    }, {
      name: 'Manches (x2 - sans boutonnière)',
      prices: {
        SIMPLE: 12,
        COMPLEX: 16
      },
      showInPlugin: true,
      id: '9.robe-rac-4'
    }, {
      name: 'Manches (x2 - boutonnière)',
      prices: {
        SIMPLE: 22,
        COMPLEX: 26
      },
      showInPlugin: true,
      id: '9.robe-rac-5'
    }, {
      name: 'Bretelles (x2)',
      isSuitableForJunior: true,
      prices: {
        SIMPLE: 8,
        COMPLEX: 18
      },
      showInPlugin: true,
      id: '9.robe-rac-6'
    }]
  }, {
    name: 'Rallonger',
    slug: 'ral_alteration',
    showInPlugin: true,
    items: [{
      name: 'Longueur simple',
      prices: {
        SIMPLE: 15,
        COMPLEX: 20
      },
      liningPrices: {
        SIMPLE: 4,
        COMPLEX: 4
      },
      showInPlugin: true,
      id: '9.robe-ral-1'
    }, {
      name: 'Longueur ample',
      prices: {
        SIMPLE: 20,
        COMPLEX: 23
      },
      liningPrices: {
        SIMPLE: 4,
        COMPLEX: 5
      },
      showInPlugin: true,
      id: '9.robe-ral-2'
    }, {
      name: 'Longueur à volants',
      prices: {
        SIMPLE: 22,
        COMPLEX: 30
      },
      liningPrices: {
        SIMPLE: 5,
        COMPLEX: 5
      },
      showInPlugin: true,
      id: '9.robe-ral-3'
    }, {
      name: 'Manches (x2 - sans boutonnière)',
      prices: {
        SIMPLE: 14,
        COMPLEX: 17
      },
      showInPlugin: true,
      id: '9.robe-ral-4'
    }, {
      name: 'Manches (x2 - boutonnière)',
      prices: {
        SIMPLE: 25,
        COMPLEX: 28
      },
      showInPlugin: true,
      id: '9.robe-ral-5'
    }, {
      name: 'Bretelles (x2)',
      prices: {
        SIMPLE: 12,
        COMPLEX: 20
      },
      showInPlugin: true,
      id: '9.robe-ral-6'
    }]
  }, (0, _commonPricings.getCommunTear)({
    slug: 'robe',
    isSuitableForJunior: true
  }), (0, _commonPricings.getCommunZips)({
    slug: 'robe',
    isSuitableForJunior: true
  }), (0, _commonPricings.getCommunButtons)({
    slug: 'robe',
    isSuitableForJunior: true
  }), (0, _commonPricings.getEmbroideryPricingsCategory)('robe'), (0, _commonPricings.getVariousPricingsCategory)({
    pieceSlug: 'robe',
    isSuitableForJunior: true
  })]
}, {
  name: 'Pull & gilet',
  slug: 'pull',
  hasMostCommonCategory: true,
  showInPlugin: true,
  types: [{
    slug: 'SIMPLE',
    name: 'Basique'
  }, {
    slug: 'COMPLEX',
    name: 'Laine & cachemire'
  }],
  categories: [{
    name: 'Cintrer',
    slug: 'cin_alteration',
    showInPlugin: true,
    items: [{
      name: 'Côtés (x2)',
      prices: {
        SIMPLE: 16,
        COMPLEX: 40
      },
      showInPlugin: true,
      id: '9.pull-cin-1'
    }, {
      name: 'Épaules (x2)',
      prices: {
        SIMPLE: 18,
        COMPLEX: 45
      },
      showInPlugin: true,
      id: '9.pull-cin-2'
    }, {
      name: 'Manches (x2 - sans boutonnière)',
      prices: {
        SIMPLE: 21,
        COMPLEX: 52
      },
      showInPlugin: true,
      id: '9.pull-cin-3'
    }, {
      name: 'Taille',
      prices: {
        SIMPLE: 18,
        COMPLEX: 45
      },
      showInPlugin: true,
      id: '9.pull-cin-4'
    }, {
      name: 'Dos',
      prices: {
        SIMPLE: 11,
        COMPLEX: 27
      },
      showInPlugin: true,
      id: '9.pull-cin-5',
      mostCommonCategoryPosition: 5,
      mostCommonCategoryLabel: 'Cintrer dos'
    }]
  }, {
    name: 'Élargir',
    slug: 'ela_alteration',
    showInPlugin: true,
    items: [{
      name: 'Côtés (x2)',
      prices: {
        SIMPLE: 17,
        COMPLEX: 42
      },
      showInPlugin: true,
      id: '9.pull-ela-1'
    }, {
      name: 'Épaules (x2)',
      prices: {
        SIMPLE: 19,
        COMPLEX: 47
      },
      showInPlugin: true,
      id: '9.pull-ela-2'
    }, {
      name: 'Manches (x2 - sans boutonnière)',
      prices: {
        SIMPLE: 24,
        COMPLEX: 60
      },
      showInPlugin: true,
      id: '9.pull-ela-3'
    }, {
      name: 'Taille',
      prices: {
        SIMPLE: 20,
        COMPLEX: 50
      },
      showInPlugin: true,
      id: '9.pull-ela-4'
    }, {
      name: 'Dos',
      prices: {
        SIMPLE: 13,
        COMPLEX: 32
      },
      showInPlugin: true,
      id: '9.pull-ela-5'
    }]
  }, {
    name: 'Raccourcir',
    slug: 'rac_alteration',
    showInPlugin: true,
    items: [{
      name: 'Longueur',
      prices: {
        SIMPLE: 14,
        COMPLEX: 35
      },
      showInPlugin: true,
      id: '9.pull-rac-1'
    }, {
      name: 'Manches (x2 - par le bas)',
      prices: {
        SIMPLE: 12,
        COMPLEX: 30
      },
      showInPlugin: true,
      id: '9.pull-rac-2'
    }, {
      name: 'Manches (x2 - par l’épaule)',
      prices: {
        SIMPLE: 37,
        COMPLEX: 92
      },
      showInPlugin: true,
      id: '9.pull-rac-3'
    }]
  }, {
    name: 'Rallonger',
    slug: 'ral_alteration',
    showInPlugin: true,
    items: [{
      name: 'Longueur',
      prices: {
        SIMPLE: 17,
        COMPLEX: 42
      },
      showInPlugin: true,
      id: '9.pull-ral-1'
    }, {
      name: 'Manches (x2 - par le bas)',
      prices: {
        SIMPLE: 12,
        COMPLEX: 30
      },
      showInPlugin: true,
      id: '9.pull-ral-2'
    }, {
      name: 'Manches (x2 - par l’épaule)',
      prices: {
        SIMPLE: 37,
        COMPLEX: 92
      },
      showInPlugin: true,
      id: '9.pull-ral-3'
    }]
  }, (0, _commonPricings.getCommunTear)({
    slug: 'pull',
    isSuitableForJunior: true
  }), (0, _commonPricings.getCommunZips)({
    slug: 'pull',
    isSuitableForJunior: true
  }), (0, _commonPricings.getCommunButtons)({
    slug: 'pull',
    isSuitableForJunior: true
  }), (0, _commonPricings.getEmbroideryPricingsCategory)('pull'), (0, _commonPricings.getVariousPricingsCategory)({
    pieceSlug: 'pull',
    isSuitableForJunior: true
  })]
}, {
  name: 'Lingerie & maillot',
  slug: 'ling',
  hasMostCommonCategory: true,
  showInPlugin: true,
  types: [{
    slug: 'SIMPLE',
    name: 'Basique'
  }, {
    slug: 'COMPLEX',
    name: 'Lingerie fine'
  }],
  categories: [{
    name: 'Cintrer',
    slug: 'cin_alteration',
    showInPlugin: true,
    items: [{
      name: 'Tour de poitrine',
      prices: {
        SIMPLE: 9,
        COMPLEX: 22
      },
      showInPlugin: true,
      id: '9.ling-cin-1'
    }, {
      name: 'Bonnets (x2)',
      prices: {
        SIMPLE: 12,
        COMPLEX: 30
      },
      liningPrices: {
        SIMPLE: 3,
        COMPLEX: 3
      },
      showInPlugin: true,
      id: '9.ling-cin-2'
    }, {
      name: 'Tour de taille',
      prices: {
        SIMPLE: 20,
        COMPLEX: 30
      },
      showInPlugin: true,
      id: '9.ling-cin-3'
    }]
  }, {
    name: 'Élargir',
    slug: 'ela_alteration',
    showInPlugin: true,
    items: [{
      name: 'Tour de poitrine',
      prices: {
        SIMPLE: 10,
        COMPLEX: 25
      },
      showInPlugin: true,
      id: '9.ling-ela-1'
    }, {
      name: 'Tour de taille',
      prices: {
        SIMPLE: 20,
        COMPLEX: 40
      },
      showInPlugin: true,
      id: '9.ling-ela-2'
    }]
  }, {
    name: 'Raccourcir',
    slug: 'rac_alteration',
    showInPlugin: true,
    items: [{
      name: 'Bretelles (x2)',
      prices: {
        SIMPLE: 8,
        COMPLEX: 20
      },
      showInPlugin: true,
      id: '9.ling-rac-1'
    }, {
      name: 'Forme culotte / caleçon',
      prices: {
        SIMPLE: 20,
        COMPLEX: 30
      },
      liningPrices: {
        SIMPLE: 2,
        COMPLEX: 2
      },
      showInPlugin: true,
      id: '9.ling-rac-2'
    }, {
      name: 'Ourlet',
      prices: {
        SIMPLE: 12
      },
      liningPrices: {
        SIMPLE: 2
      },
      showInPlugin: true,
      id: '9.ling-rac-3',
      mostCommonCategoryPosition: 5
    }]
  }, {
    name: 'Rallonger',
    slug: 'ral_alteration',
    showInPlugin: true,
    items: [{
      name: 'Bretelles (x2)',
      prices: {
        SIMPLE: 9,
        COMPLEX: 22
      },
      showInPlugin: true,
      id: '9.ling-ral-1'
    }, {
      name: 'Forme culotte / caleçon',
      prices: {
        SIMPLE: 22,
        COMPLEX: 35
      },
      liningPrices: {
        SIMPLE: 2,
        COMPLEX: 2
      },
      showInPlugin: true,
      id: '9.ling-ral-2'
    }, {
      name: 'Longueur',
      prices: {
        SIMPLE: 14
      },
      liningPrices: {
        SIMPLE: 3
      },
      showInPlugin: true,
      id: '9.ling-ral-3'
    }]
  }, (0, _commonPricings.getCommunTear)({
    slug: 'ling'
  }), (0, _commonPricings.getCommunZips)({
    slug: 'ling'
  }), (0, _commonPricings.getCommunButtons)({
    slug: 'ling'
  }), (0, _commonPricings.getEmbroideryPricingsCategory)('ling'), (0, _commonPricings.getVariousPricingsCategory)({
    pieceSlug: 'ling'
  })]
}, {
  name: 'Combinaison',
  slug: 'comb',
  hasMostCommonCategory: true,
  showInPlugin: true,
  types: [{
    slug: 'SIMPLE',
    name: 'Basique'
  }, {
    slug: 'COMPLEX',
    name: 'Habillée'
  }],
  categories: [{
    name: 'Cintrer',
    slug: 'cin_alteration',
    showInPlugin: true,
    items: [{
      name: 'Épaules (x2)',
      prices: {
        SIMPLE: 14.5,
        COMPLEX: 29
      },
      showInPlugin: true,
      id: '9.comb-cin-1'
    }, {
      name: 'Manches (x2)',
      prices: {
        SIMPLE: 14.5,
        COMPLEX: 29
      },
      showInPlugin: true,
      id: '9.comb-cin-2'
    }, {
      name: 'Taille',
      prices: {
        SIMPLE: 14.5,
        COMPLEX: 25
      },
      showInPlugin: true,
      id: '9.comb-cin-3'
    }, {
      name: 'Dos',
      prices: {
        SIMPLE: 9,
        COMPLEX: 18
      },
      showInPlugin: true,
      id: '9.comb-cin-4'
    }, {
      name: 'Ceinture',
      prices: {
        SIMPLE: 32,
        COMPLEX: 42
      },
      liningPrices: {
        COMPLEX: 11
      },
      showInPlugin: true,
      id: '9.comb-cin-5'
    }, {
      name: 'Jambes (x2)',
      prices: {
        SIMPLE: 42,
        COMPLEX: 45
      },
      liningPrices: {
        COMPLEX: 9
      },
      showInPlugin: true,
      id: '9.comb-cin-6'
    }, {
      name: 'Bas de jambes (x2)',
      prices: {
        SIMPLE: 22,
        COMPLEX: 24
      },
      liningPrices: {
        COMPLEX: 8
      },
      showInPlugin: true,
      id: '9.comb-cin-7',
      mostCommonCategoryPosition: 5,
      mostCommonCategoryLabel: 'Cintrer bas de jambes'
    }, {
      name: 'Entrejambe',
      prices: {
        SIMPLE: 15,
        COMPLEX: 22
      },
      liningPrices: {
        COMPLEX: 9
      },
      showInPlugin: true,
      id: '9.comb-cin-8'
    }]
  }, {
    name: 'Élargir',
    slug: 'ela_alteration',
    showInPlugin: true,
    items: [{
      name: 'Épaules (x2)',
      prices: {
        SIMPLE: 15,
        COMPLEX: 32
      },
      showInPlugin: true,
      id: '9.comb-ela-1'
    }, {
      name: 'Manches (x2)',
      prices: {
        SIMPLE: 15,
        COMPLEX: 32
      },
      showInPlugin: true,
      id: '9.comb-ela-2'
    }, {
      name: 'Taille',
      prices: {
        SIMPLE: 15,
        COMPLEX: 28
      },
      showInPlugin: true,
      id: '9.comb-ela-3'
    }, {
      name: 'Dos',
      prices: {
        SIMPLE: 10,
        COMPLEX: 20
      },
      showInPlugin: true,
      id: '9.comb-ela-4'
    }, {
      name: 'Ceinture',
      prices: {
        SIMPLE: 38,
        COMPLEX: 47
      },
      liningPrices: {
        COMPLEX: 12
      },
      showInPlugin: true,
      id: '9.comb-ela-5'
    }, {
      name: 'Jambes (x2)',
      prices: {
        SIMPLE: 47,
        COMPLEX: 50
      },
      liningPrices: {
        COMPLEX: 10
      },
      showInPlugin: true,
      id: '9.comb-ela-6'
    }, {
      name: 'Bas de jambes (x2)',
      prices: {
        SIMPLE: 27,
        COMPLEX: 27
      },
      liningPrices: {
        COMPLEX: 9
      },
      showInPlugin: true,
      id: '9.comb-ela-7'
    }, {
      name: 'Entrejambe',
      prices: {
        SIMPLE: 20,
        COMPLEX: 27
      },
      liningPrices: {
        COMPLEX: 10
      },
      showInPlugin: true,
      id: '9.comb-ela-8'
    }]
  }, {
    name: 'Raccourcir',
    slug: 'rac_alteration',
    showInPlugin: true,
    items: [{
      name: 'Manches (x2 - par le bas)',
      prices: {
        SIMPLE: 10,
        COMPLEX: 23
      },
      showInPlugin: true,
      id: '9.comb-rac-1'
    }, {
      name: 'Manches (x2 - par l’épaule)',
      prices: {
        SIMPLE: 28,
        COMPLEX: 65
      },
      showInPlugin: true,
      id: '9.comb-rac-2'
    }, {
      name: 'Ourlet simple (x2)',
      isSuitableForJunior: true,
      prices: {
        SIMPLE: 12,
        COMPLEX: 17
      },
      liningPrices: {
        COMPLEX: 7
      },
      showInPlugin: true,
      id: '9.comb-rac-3',
      mostCommonCategoryPosition: 1
    }, {
      name: 'Ourlet revers (x2)',
      isSuitableForJunior: true,
      prices: {
        SIMPLE: 15,
        COMPLEX: 20
      },
      liningPrices: {
        COMPLEX: 9
      },
      showInPlugin: true,
      id: '9.comb-rac-4'
    }, {
      name: 'Bretelles (x2 - par l’épaule)',
      prices: {
        SIMPLE: 8,
        COMPLEX: 18
      },
      id: '9.comb-rac-9'
    }]
  }, {
    name: 'Rallonger',
    slug: 'ral_alteration',
    showInPlugin: true,
    items: [{
      name: 'Manches (x2 - par le bas)',
      prices: {
        SIMPLE: 12,
        COMPLEX: 27
      },
      showInPlugin: true,
      id: '9.comb-ral-1'
    }, {
      name: 'Manches (x2 - par l’épaule)',
      prices: {
        SIMPLE: 30,
        COMPLEX: 75
      },
      showInPlugin: true,
      id: '9.comb-ral-2'
    }, {
      name: 'Jambes (x2)',
      prices: {
        SIMPLE: 15,
        COMPLEX: 20
      },
      liningPrices: {
        COMPLEX: 9
      },
      showInPlugin: true,
      id: '9.comb-ral-3'
    }]
  }, (0, _commonPricings.getCommunTear)({
    slug: 'comb',
    isSuitableForJunior: true
  }), (0, _commonPricings.getCommunZips)({
    slug: 'comb',
    isSuitableForJunior: true
  }), (0, _commonPricings.getCommunButtons)({
    slug: 'comb',
    isSuitableForJunior: true
  }), (0, _commonPricings.getEmbroideryPricingsCategory)('comb'), (0, _commonPricings.getVariousPricingsCategory)({
    pieceSlug: 'comb',
    isSuitableForJunior: true
  })]
}, {
  name: 'Robe de mariée',
  slug: 'mari',
  hasMostCommonCategory: true,
  types: undefined,
  categories: [{
    name: 'Cintrer',
    slug: 'cin_alteration',
    items: [{
      name: 'Côtés (x2)',
      prices: {
        DEFAULT: 63
      },
      liningPrices: {
        DEFAULT: 28
      },
      id: '9.mari-cin-1'
    }, {
      name: 'Épaules (x2)',
      prices: {
        DEFAULT: 42
      },
      liningPrices: {
        DEFAULT: 8
      },
      id: '9.mari-cin-2'
    }, {
      name: 'Manches (x2 - sans boutonnière)',
      prices: {
        DEFAULT: 49
      },
      id: '9.mari-cin-3'
    }, {
      name: 'Manches (x2 - boutonnière)',
      prices: {
        DEFAULT: 63
      },
      id: '9.mari-cin-4'
    }, {
      name: 'Bustier / taille',
      prices: {
        DEFAULT: 70
      },
      liningPrices: {
        DEFAULT: 8
      },
      id: '9.mari-cin-5',
      mostCommonCategoryPosition: 5,
      mostCommonCategoryLabel: 'Cintrer taille'
    }, {
      name: 'Dos',
      prices: {
        DEFAULT: 63
      },
      liningPrices: {
        DEFAULT: 8
      },
      id: '9.mari-cin-6'
    }]
  }, {
    name: 'Élargir',
    slug: 'ela_alteration',
    items: [{
      name: 'Côtés (x2)',
      prices: {
        DEFAULT: 63
      },
      liningPrices: {
        DEFAULT: 28
      },
      id: '9.mari-ela-1'
    }, {
      name: 'Épaules (x2)',
      prices: {
        DEFAULT: 42
      },
      liningPrices: {
        DEFAULT: 8
      },
      id: '9.mari-ela-2'
    }, {
      name: 'Manches (x2 - sans boutonnière)',
      prices: {
        DEFAULT: 49
      },
      id: '9.mari-ela-3'
    }, {
      name: 'Manches (x2 - boutonnière)',
      prices: {
        DEFAULT: 63
      },
      id: '9.mari-ela-4'
    }, {
      name: 'Bustier / taille',
      prices: {
        DEFAULT: 70
      },
      liningPrices: {
        DEFAULT: 8
      },
      id: '9.mari-ela-5'
    }, {
      name: 'Dos',
      prices: {
        DEFAULT: 63
      },
      liningPrices: {
        DEFAULT: 8
      },
      id: '9.mari-ela-6'
    }]
  }, {
    name: 'Raccourcir',
    slug: 'rac_alteration',
    items: [{
      name: 'Ourlet simple',
      prices: {
        DEFAULT: 63
      },
      liningPrices: {
        DEFAULT: 13
      },
      id: '9.mari-rac-1',
      mostCommonCategoryPosition: 1
    }, {
      name: 'Ourlet à volants',
      prices: {
        DEFAULT: 84
      },
      liningPrices: {
        DEFAULT: 15
      },
      id: '9.mari-rac-2'
    }, {
      name: 'Ourlet revers',
      prices: {
        DEFAULT: 65
      },
      liningPrices: {
        DEFAULT: 13
      },
      id: '9.mari-rac-3'
    }, {
      name: 'Manches (x2 - sans boutonnière)',
      prices: {
        DEFAULT: 23
      },
      id: '9.mari-rac-4'
    }, {
      name: 'Manches (x2 - boutonnière)',
      prices: {
        DEFAULT: 32
      },
      id: '9.mari-rac-5'
    }, {
      name: 'Bretelles (x2)',
      prices: {
        DEFAULT: 28
      },
      id: '9.mari-rac-6'
    }]
  }, {
    name: 'Rallonger',
    slug: 'ral_alteration',
    items: [{
      name: 'Longueur simple',
      prices: {
        DEFAULT: 63
      },
      liningPrices: {
        DEFAULT: 13
      },
      id: '9.mari-ral-1'
    }, {
      name: 'Longueur à volants',
      prices: {
        DEFAULT: 84
      },
      liningPrices: {
        DEFAULT: 15
      },
      id: '9.mari-ral-2'
    }, {
      name: 'Ourlets (x2) : suppression des revers',
      prices: {
        DEFAULT: 59
      },
      liningPrices: {
        DEFAULT: 11
      },
      id: '9.mari-ral-3'
    }, {
      name: 'Manches (x2 - sans boutonnière)',
      prices: {
        DEFAULT: 23
      },
      id: '9.mari-ral-4'
    }, {
      name: 'Manches (x2 - boutonnière)',
      prices: {
        DEFAULT: 32
      },
      id: '9.mari-ral-5'
    }, {
      name: 'Bretelles (x2)',
      prices: {
        DEFAULT: 28
      },
      id: '9.mari-ral-6'
    }]
  }, {
    name: 'Déchirures / trous',
    slug: 'tear_repair',
    showInPlugin: true,
    items: [{
      name: 'Déchirure : réparation',
      prices: {
        DEFAULT: 21
      },
      liningPrices: {
        DEFAULT: 8
      },
      id: '9.mari-tear-1',
      multiple: true,
      repairBonus: 'HOLE'
    }, {
      name: 'Couture complexe avec empiècement',
      prices: {
        DEFAULT: 35
      },
      id: '9.mari-tear-2',
      multiple: true,
      repairBonus: 'HOLE'
    }, {
      name: 'Trou : raccommodage simple',
      prices: {
        DEFAULT: 12
      },
      id: '9.mari-tear-3',
      multiple: true,
      repairBonus: 'UNTIED_UNLINED'
    }]
  }, {
    name: 'Zips',
    slug: 'zip_repair',
    showInPlugin: true,
    items: [{
      name: 'Zip court (< 25cm) fourni par le Tilliste : ajout / remplacement / retrait',
      prices: {
        DEFAULT: 49
      },
      liningPrices: {
        DEFAULT: 13
      },
      id: '9.mari-zip-1',
      multiple: true,
      repairBonus: 'ZIP_SMALL'
    }, {
      name: 'Zip moyen (25-40cm) fourni par le Tilliste : ajout / remplacement / retrait',
      prices: {
        DEFAULT: 56
      },
      liningPrices: {
        DEFAULT: 13
      },
      id: '9.mari-zip-2',
      multiple: true,
      repairBonus: 'ZIP_BIG'
    }, {
      name: 'Zip long (40-80cm) fourni par le Tilliste : ajout / remplacement / retrait',
      prices: {
        DEFAULT: 62
      },
      liningPrices: {
        DEFAULT: 12
      },
      id: '9.mari-zip-3',
      multiple: true,
      repairBonus: 'ZIP_BIG'
    }, {
      name: 'Zip invisible court (< 25cm) fourni par le Tilliste : ajout / remplacement / retrait',
      prices: {
        DEFAULT: 56
      },
      liningPrices: {
        DEFAULT: 12
      },
      id: '9.mari-zip-4',
      multiple: true,
      repairBonus: 'ZIP_SMALL'
    }, {
      name: 'Zip invisible long (40-80cm) fourni par le Tilliste : ajout / remplacement / retrait',
      prices: {
        DEFAULT: 63
      },
      liningPrices: {
        DEFAULT: 15
      },
      id: '9.mari-zip-5',
      multiple: true,
      repairBonus: 'ZIP_BIG'
    }, {
      name: 'Zip court (< 25cm) fourni par le client : ajout / remplacement / retrait',
      prices: {
        DEFAULT: 47
      },
      liningPrices: {
        DEFAULT: 13
      },
      id: '9.mari-zip-6',
      multiple: true,
      repairBonus: 'ZIP_SMALL'
    }, {
      name: 'Zip long (40-80cm) fourni par le client : ajout / remplacement / retrait',
      prices: {
        DEFAULT: 53
      },
      liningPrices: {
        DEFAULT: 12
      },
      id: '9.mari-zip-7',
      multiple: true,
      repairBonus: 'ZIP_BIG'
    }, {
      name: 'Zip invisible court (< 25cm) fourni par le client : ajout / remplacement / retrait',
      prices: {
        DEFAULT: 43
      },
      liningPrices: {
        DEFAULT: 12
      },
      id: '9.mari-zip-8',
      multiple: true,
      repairBonus: 'ZIP_SMALL'
    }, {
      name: 'Zip invisible long (40-80cm) fourni par le client : ajout / remplacement / retrait',
      prices: {
        DEFAULT: 50
      },
      liningPrices: {
        DEFAULT: 15
      },
      id: '9.mari-zip-9',
      multiple: true,
      repairBonus: 'ZIP_BIG'
    }, {
      name: 'Zip invisible moyen (25-40cm) fourni par le Tilliste : ajout / remplacement / retrait',
      prices: {
        DEFAULT: 60
      },
      liningPrices: {
        DEFAULT: 13
      },
      id: '9.mari-zip-10',
      multiple: true,
      repairBonus: 'ZIP_BIG'
    }, {
      name: 'Zip moyen (25-40cm) fourni par le client : ajout / remplacement / retrait',
      prices: {
        DEFAULT: 50
      },
      liningPrices: {
        DEFAULT: 13
      },
      id: '9.mari-zip-11',
      multiple: true,
      repairBonus: 'ZIP_BIG'
    }, {
      name: 'Zip invisible moyen (25-40cm) fourni par le client : ajout / remplacement / retrait',
      prices: {
        DEFAULT: 47
      },
      liningPrices: {
        DEFAULT: 13
      },
      id: '9.mari-zip-12',
      multiple: true,
      repairBonus: 'ZIP_BIG'
    }]
  }, {
    name: 'Boutons',
    slug: 'but_repair',
    showInPlugin: true,
    items: [{
      name: 'Boutonnière (x1) : création',
      prices: {
        DEFAULT: 10
      },
      liningPrices: {
        DEFAULT: 2
      },
      id: '9.mari-but-1',
      multiple: true
    }, {
      name: 'Bouton (x1) fourni par le Tilliste : ajout / remplacement',
      prices: {
        DEFAULT: 4
      },
      id: '9.mari-but-2',
      multiple: true
    }, {
      name: 'Bouton pression (x1) fourni par le client : ajout / remplacement',
      prices: {
        DEFAULT: 10
      },
      id: '9.mari-but-3',
      multiple: true
    }, {
      name: 'Bouton (x1) fourni par le client : ajout / remplacement',
      prices: {
        DEFAULT: 2
      },
      id: '9.mari-but-4',
      multiple: true
    }, {
      name: 'Bouton pression à coudre (x1) fourni par le Tilliste : ajout / remplacement',
      prices: {
        DEFAULT: 3
      },
      id: '9.mari-but-5',
      multiple: true
    }, {
      name: 'Bouton pression à coudre (x1) fourni par le client : ajout / remplacement',
      prices: {
        DEFAULT: 2
      },
      id: '9.mari-but-6',
      multiple: true
    }, {
      name: 'Bouton pression - Jersey, Anorak & Sport Camping (x1) fourni par le Tilliste : ajout / remplacement',
      prices: {
        DEFAULT: 8
      },
      id: '9.mari-but-7',
      multiple: true
    }, {
      name: 'Bouton pression - Jersey, Anorak & Sport Camping (x1) fourni par le client : ajout / remplacement',
      prices: {
        DEFAULT: 6
      },
      id: '9.mari-but-8',
      multiple: true
    }]
  }, (0, _commonPricings.getEmbroideryPricingsCategory)('mari', 'mari'), (0, _commonPricings.getVariousPricingsCategory)({
    pieceSlug: 'mari',
    type: 'mari'
  })]
}, {
  name: 'Accessoires',
  slug: 'acce',
  hasMostCommonCategory: false,
  showInPlugin: false,
  types: [{
    slug: 'SIMPLE',
    name: 'Basique'
  }, {
    slug: 'COMPLEX',
    name: 'Habillé'
  }],
  categories: [(0, _commonPricings.getCommunTear)({
    slug: 'acce',
    isSuitableForJunior: true
  }), (0, _commonPricings.getCommunZips)({
    slug: 'acce',
    isSuitableForJunior: true
  }), (0, _commonPricings.getCommunButtons)({
    slug: 'acce',
    isSuitableForJunior: true
  }), (0, _commonPricings.getEmbroideryPricingsCategory)('acce'), {
    name: 'Divers',
    slug: 'divers',
    items: [{
      name: 'Doublure : ajout / remplacement',
      prices: {
        SIMPLE: 9,
        COMPLEX: 12
      },
      id: '9.acce-div-1'
    }].concat(_toConsumableArray((0, _commonPricings.getPricingsItemsWithIds)((0, _commonPricings.getFilteredVariousPricingsItems)('acce', ['Doublure : ajout / remplacement']), 'div', 'acce', undefined, 1, true)))
  }]
}, {
  name: 'Décoration',
  slug: 'deco',
  hasMostCommonCategory: false,
  types: undefined,
  categories: [{
    name: 'Rideaux',
    slug: 'ride',
    items: [{
      name: 'Ourlet - largeur <199cm',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 20
      },
      liningPrices: {
        DEFAULT: 10
      },
      id: '9.deco-rid-1',
      multiple: true
    }, {
      name: 'Ourlet - largeur >200cm',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 30
      },
      liningPrices: {
        DEFAULT: 10
      },
      id: '9.deco-rid-2',
      multiple: true
    }, {
      name: 'Supplément fil de plomb',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 10
      },
      id: '9.deco-rid-3',
      multiple: true
    }, {
      name: 'Assemblage côté - hauteur <199cm',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 30
      },
      liningPrices: {
        DEFAULT: 10
      },
      id: '9.deco-rid-4',
      multiple: true
    }, {
      name: 'Assemblage côté - hauteur >200cm',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 40
      },
      liningPrices: {
        DEFAULT: 10
      },
      id: '9.deco-rid-5',
      multiple: true
    }, {
      name: 'Ajout de fronces - largeur <199cm',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 30
      },
      id: '9.deco-rid-6',
      multiple: true
    }, {
      name: 'Ajout de fronces - largeur >200cm',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 37
      },
      id: '9.deco-rid-7',
      multiple: true
    }, {
      name: 'Dépose/pose d’un pan de rideau',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 7
      },
      id: '9.deco-rid-8',
      multiple: true
    }].concat(_toConsumableArray((0, _commonPricings.getPricingsItemsWithIds)((0, _commonPricings.getFilteredVariousPricingsItems)('deco'), 'rid', 'deco', 'SIMPLE', 8, true)))
  }, {
    name: 'Coussins',
    slug: 'cous',
    items: [{
      name: 'Coussin (moins de 45 cm)',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 14
      },
      id: '9.deco-cou-1',
      multiple: true
    }, {
      name: 'Coussin (plus de 45 cm)',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 18
      },
      id: '9.deco-cou-2',
      multiple: true
    }, {
      name: 'Doublure : ajout / remplacement',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 9
      },
      id: '9.deco-cou-3'
    }].concat(_toConsumableArray((0, _commonPricings.getPricingsItemsWithIds)((0, _commonPricings.getFilteredVariousPricingsItems)('deco', ['Doublure : ajout / remplacement']), 'cou', 'deco', 'SIMPLE', 3, true)))
  }, {
    name: 'Linge de table',
    slug: 'tableClothes',
    items: _toConsumableArray((0, _commonPricings.getPricingsItemsWithIds)((0, _commonPricings.getFilteredVariousPricingsItems)('deco', ['Doublure : ajout / remplacement']), 'nap', 'deco', 'SIMPLE', 3, true))
  }, {
    name: 'Housse de chaise',
    slug: 'chair',
    items: _toConsumableArray((0, _commonPricings.getPricingsItemsWithIds)((0, _commonPricings.getFilteredVariousPricingsItems)('deco', ['Doublure : ajout / remplacement']), 'chai', 'deco', 'SIMPLE', 3, true))
  }, {
    name: 'Housse de canapé',
    slug: 'sofa',
    items: _toConsumableArray((0, _commonPricings.getPricingsItemsWithIds)((0, _commonPricings.getFilteredVariousPricingsItems)('deco', ['Doublure : ajout / remplacement']), 'sofa', 'deco', 'SIMPLE', 3, true))
  }, {
    name: 'Linge de maison',
    slug: 'mais',
    items: [{
      name: 'Raccourcir longueur - plus d’1m60',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 20
      },
      id: '9.deco-mai-1',
      multiple: true
    }, {
      name: 'Raccourcir largeur - plus d’1m60',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 20
      },
      id: '9.deco-mai-2',
      multiple: true
    }, {
      name: 'Raccourcir longueur et largeur - plus d’1m60',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 40
      },
      id: '9.deco-mai-3',
      multiple: true
    }, {
      name: 'Raccourcir longueur - moins d’1m60',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 15
      },
      id: '9.deco-mai-4',
      multiple: true
    }, {
      name: 'Raccourcir largeur - moins d’1m60',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 15
      },
      id: '9.deco-mai-5',
      multiple: true
    }, {
      name: 'Raccourcir longueur et largeur - moins d’1m60',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 30
      },
      id: '9.deco-mai-6',
      multiple: true
    }, {
      name: 'Raccourcir longueur - moins d’1m',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 10
      },
      id: '9.deco-mai-7',
      multiple: true
    }, {
      name: 'Raccourcir largeur - moins d’1m',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 10
      },
      id: '9.deco-mai-8',
      multiple: true
    }, {
      name: 'Raccourcir longueur et largeur - moins d’1m',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 20
      },
      id: '9.deco-mai-9',
      multiple: true
    }].concat(_toConsumableArray((0, _commonPricings.getPricingsItemsWithIds)((0, _commonPricings.getFilteredVariousPricingsItems)('deco'), 'mai', 'deco', 'SIMPLE', 9, true)))
  }, (0, _commonPricings.getEmbroideryPricingsCategory)('deco', 'SIMPLE'), (0, _commonPricings.getCommunMachineEmbroidery)({
    slug: 'deco'
  })]
}, {
  name: 'Autre',
  slug: 'autr',
  hasMostCommonCategory: false,
  showInPlugin: false,
  types: undefined,
  categories: [{
    name: 'Divers',
    slug: 'divers',
    items: [{
      name: '1h de conseil basique',
      prices: {
        DEFAULT: 20
      },
      id: '9.autr-div-1'
    }, {
      name: 'Prise de mesure',
      prices: {
        DEFAULT: 20
      },
      id: '9.autr-div-2'
    }, {
      name: '1h de conseil robe de mariée',
      prices: {
        DEFAULT: 60
      },
      id: '9.autr-div-3'
    }, {
      name: '1h de conseil tailleur',
      prices: {
        DEFAULT: 50
      },
      id: '9.autr-div-4'
    }, {
      name: '1h de conseil broderie, maille , sport & bain',
      prices: {
        DEFAULT: 30
      },
      id: '9.autr-div-5'
    }]
  }]
}, {
  name: 'Création de totebag',
  slug: 'crea_tote',
  hasMostCommonCategory: false,
  showInPlugin: false,
  autoId: true,
  isSuitableForJunior: true,
  types: [{
    slug: 'SIMPLE_SMALL',
    name: 'Forme simple - classique : côtés < 50 cm'
  }, {
    slug: 'COMPLEX_SMALL',
    name: 'Forme originale - classique : côtés < 50 cm'
  }, {
    slug: 'SIMPLE_BIG',
    name: 'Forme simple - grand : côtés > 51 cm'
  }, {
    slug: 'COMPLEX_BIG',
    name: 'Forme originale - grand : côtés > 51 cm'
  }],
  autoComplexFactor: 2,
  autoPrices: true,
  categories: [{
    name: 'Dimensions',
    slug: 'sizes',
    autoIdPrefix: 'dime',
    items: [{
      name: 'Classique : côtés < 50 cm',
      prices: {
        SIMPLE_SMALL: 10
      }
    }, {
      name: 'Grand : côtés > 51 cm',
      prices: {
        SIMPLE_BIG: 15
      }
    }]
  }, {
    name: 'Anses',
    slug: 'handles',
    autoIdPrefix: 'anse',
    items: [{
      name: 'Chaîne + oeillets',
      prices: {
        SIMPLE_SMALL: 15,
        SIMPLE_BIG: 15
      }
    }, {
      name: 'Tissu',
      prices: {
        SIMPLE_SMALL: 2,
        SIMPLE_BIG: 3
      }
    }, {
      name: 'Autre / fourni par le client',
      prices: {
        SIMPLE_SMALL: 2,
        SIMPLE_BIG: 2
      }
    }]
  }, {
    name: 'Fermetures',
    slug: 'closures',
    autoIdPrefix: 'ferm',
    autoMultiple: true,
    items: (0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_tote',
      autoComplexFactor: 1,
      isClosingsOnly: true
    })
  }, {
    name: 'Suppléments / toppings',
    slug: 'extras',
    autoIdPrefix: 'supp',
    autoMultiple: true,
    items: [{
      name: 'Doublure',
      prices: {
        SIMPLE_SMALL: 9,
        SIMPLE_BIG: 9
      }
    }, {
      name: 'Molleton',
      prices: {
        SIMPLE_SMALL: 5,
        SIMPLE_BIG: 7
      }
    }, {
      name: 'Thermocollant',
      prices: {
        SIMPLE_SMALL: 5,
        SIMPLE_BIG: 7
      }
    }].concat(_toConsumableArray((0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_tote',
      autoComplexFactor: 1
    })))
  }]
}, {
  name: 'Création de sac',
  slug: 'crea_sac',
  hasMostCommonCategory: false,
  autoId: true,
  showInPlugin: false,
  isSuitableForJunior: true,
  types: [{
    slug: 'SIMPLE_SMALL',
    name: 'Forme simple - petit : côtés < 35 cm'
  }, {
    slug: 'COMPLEX_SMALL',
    name: 'Forme originale - petit : côtés < 35 cm'
  }, {
    slug: 'SIMPLE_MEDIUM',
    name: 'Forme simple - moyen : 36 cm < côtés < 50 cm'
  }, {
    slug: 'COMPLEX_MEDIUM',
    name: 'Forme originale - moyen : 36 cm < côtés < 50 cm'
  }, {
    slug: 'SIMPLE_BIG',
    name: 'Forme simple : côtés > 51 cm'
  }, {
    slug: 'COMPLEX_BIG',
    name: 'Forme originale : côtés > 51 cm'
  }],
  autoComplexFactor: 2,
  autoPrices: true,
  categories: [{
    name: 'Dimensions',
    slug: 'sizes',
    autoIdPrefix: 'dime',
    items: [{
      name: 'Petit : côtés < 35 cm',
      prices: {
        SIMPLE_SMALL: 10
      }
    }, {
      name: 'Moyen : 36 cm < côtés < 50 cm',
      prices: {
        SIMPLE_MEDIUM: 15
      }
    }, {
      name: 'Grand : côtés > 51 cm',
      prices: {
        SIMPLE_BIG: 20
      }
    }]
  }, {
    name: 'Anses',
    slug: 'handles',
    autoIdPrefix: 'anse',
    items: [{
      name: 'Chaîne + oeillets',
      prices: {
        SIMPLE_SMALL: 15,
        SIMPLE_MEDIUM: 15,
        SIMPLE_BIG: 15
      }
    }, {
      name: 'Tissu',
      prices: {
        SIMPLE_SMALL: 5,
        SIMPLE_MEDIUM: 5,
        SIMPLE_BIG: 5
      }
    }, {
      name: 'Autre / fourni par le client',
      prices: {
        SIMPLE_SMALL: 5,
        SIMPLE_MEDIUM: 5,
        SIMPLE_BIG: 5
      }
    }]
  }, {
    name: 'Fermetures',
    slug: 'closures',
    autoIdPrefix: 'ferm',
    autoMultiple: true,
    items: (0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_sac',
      autoComplexFactor: 1,
      isClosingsOnly: true
    })
  }, {
    name: 'Suppléments / toppings',
    slug: 'extras',
    autoIdPrefix: 'supp',
    autoMultiple: true,
    items: [{
      name: 'Doublure',
      prices: {
        SIMPLE_SMALL: 9,
        SIMPLE_MEDIUM: 9,
        SIMPLE_BIG: 9
      }
    }, {
      name: 'Molleton',
      prices: {
        SIMPLE_SMALL: 5,
        SIMPLE_MEDIUM: 6,
        SIMPLE_BIG: 8
      }
    }, {
      name: 'Thermocollant',
      prices: {
        SIMPLE_SMALL: 5,
        SIMPLE_MEDIUM: 6,
        SIMPLE_BIG: 8
      }
    }, {
      name: 'Clous de protection',
      prices: {
        SIMPLE_SMALL: 5,
        SIMPLE_MEDIUM: 7,
        SIMPLE_BIG: 10
      }
    }].concat(_toConsumableArray((0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_sac',
      autoComplexFactor: 1
    })))
  }]
}, {
  name: 'Création de pochette',
  slug: 'crea_poch',
  hasMostCommonCategory: false,
  autoId: true,
  showInPlugin: false,
  isSuitableForJunior: true,
  types: [{
    slug: 'SIMPLE_SMALL',
    name: 'Forme simple - petit (15x10cm)'
  }, {
    slug: 'COMPLEX_SMALL',
    name: 'Forme originale - petit (15x10cm)'
  }, {
    slug: 'SIMPLE_MEDIUM',
    name: 'Forme simple - moyen (20x20cm)'
  }, {
    slug: 'COMPLEX_MEDIUM',
    name: 'Forme originale - moyen (20x20cm)'
  }, {
    slug: 'SIMPLE_BIG',
    name: 'Forme simple - grand (>25cm)'
  }, {
    slug: 'COMPLEX_BIG',
    name: 'Forme originale - grand (>25cm)'
  }],
  autoComplexFactor: 2,
  autoPrices: true,
  categories: [{
    name: 'Dimensions',
    slug: 'sizes',
    autoIdPrefix: 'dime',
    items: [{
      name: 'Petit 15x10cm',
      prices: {
        SIMPLE_SMALL: 7
      }
    }, {
      name: 'Moyen 20x20cm',
      prices: {
        SIMPLE_MEDIUM: 12
      }
    }, {
      name: 'Grand > 25cm',
      prices: {
        SIMPLE_BIG: 18
      }
    }]
  }, {
    name: 'Anses',
    slug: 'handles',
    autoIdPrefix: 'anse',
    items: [{
      name: 'Chaîne + oeillets',
      prices: {
        SIMPLE_SMALL: 15,
        SIMPLE_MEDIUM: 15,
        SIMPLE_BIG: 15
      }
    }, {
      name: 'Tissu',
      prices: {
        SIMPLE_SMALL: 2,
        SIMPLE_MEDIUM: 2,
        SIMPLE_BIG: 2
      }
    }, {
      name: 'Autre / fourni par le client',
      prices: {
        SIMPLE_SMALL: 2,
        SIMPLE_MEDIUM: 2,
        SIMPLE_BIG: 2
      }
    }]
  }, {
    name: 'Fermetures',
    slug: 'closures',
    autoIdPrefix: 'ferm',
    autoMultiple: true,
    items: (0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_poch',
      autoComplexFactor: 1,
      isClosingsOnly: true
    })
  }, {
    name: 'Suppléments / toppings',
    slug: 'extras',
    autoIdPrefix: 'supp',
    autoMultiple: true,
    items: [{
      name: 'Doublure',
      prices: {
        SIMPLE_SMALL: 9,
        SIMPLE_MEDIUM: 9,
        SIMPLE_BIG: 9
      }
    }, {
      name: 'Molleton',
      prices: {
        SIMPLE_SMALL: 5,
        SIMPLE_MEDIUM: 7,
        SIMPLE_BIG: 8
      }
    }, {
      name: 'Thermocollant',
      prices: {
        SIMPLE_SMALL: 5,
        SIMPLE_MEDIUM: 7,
        SIMPLE_BIG: 8
      }
    }].concat(_toConsumableArray((0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_poch',
      autoComplexFactor: 1
    })))
  }]
}, {
  name: 'Création de housse de coussin',
  slug: 'crea_hous',
  autoId: true,
  hasMostCommonCategory: false,
  showInPlugin: false,
  isSuitableForJunior: true,
  types: [{
    slug: 'SIMPLE_SMALL',
    name: 'Forme simple - petit (<45cm)'
  }, {
    slug: 'COMPLEX_SMALL',
    name: 'Forme originale - petit (<45cm)'
  }, {
    slug: 'SIMPLE_BIG',
    name: 'Forme simple - grand (>45cm)'
  }, {
    slug: 'COMPLEX_BIG',
    name: 'Forme originale - grand (>45cm)'
  }],
  autoComplexFactor: 2,
  autoPrices: true,
  categories: [{
    name: 'Dimensions',
    slug: 'sizes',
    autoIdPrefix: 'dime',
    items: [{
      name: 'Petit < 45cm',
      prices: {
        SIMPLE_SMALL: 14
      }
    }, {
      name: 'Grand > 45cm',
      prices: {
        SIMPLE_BIG: 18
      }
    }]
  }, {
    name: 'Fermetures',
    slug: 'closures',
    autoIdPrefix: 'ferm',
    autoMultiple: true,
    items: (0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_hous',
      autoComplexFactor: 1,
      isClosingsOnly: true
    })
  }, {
    name: 'Suppléments / toppings',
    slug: 'extras',
    autoIdPrefix: 'supp',
    autoMultiple: true,
    items: [{
      name: 'Doublure',
      prices: {
        SIMPLE_SMALL: 9,
        SIMPLE_BIG: 9
      }
    }, {
      name: 'Molleton',
      prices: {
        SIMPLE_SMALL: 5,
        SIMPLE_BIG: 8
      }
    }, {
      name: 'Thermocollant',
      prices: {
        SIMPLE_SMALL: 5,
        SIMPLE_BIG: 8
      }
    }].concat(_toConsumableArray((0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_hous',
      autoComplexFactor: 1
    })))
  }]
}, {
  name: 'Création de housse d’assise',
  slug: 'crea_assi',
  types: (0, _sofaCreation.getSeatAndBackTypes)(),
  subTypes: _sofaCreation.seatAndBackSubTypes,
  autoId: true,
  hasMostCommonCategory: false,
  showInPlugin: false,
  autoPrices: true,
  categories: [{
    name: 'Suppléments / toppings',
    slug: 'extras',
    autoIdPrefix: 'supp',
    items: [{
      name: 'Passepoil',
      priceForAllTypes: 20,
      multiple: true
    }].concat(_toConsumableArray((0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_assi'
    })))
  }]
}, {
  name: 'Création de housse de dossier',
  slug: 'crea_doss',
  types: (0, _sofaCreation.getSeatAndBackTypes)(false),
  subTypes: _sofaCreation.seatAndBackSubTypes,
  autoId: true,
  hasMostCommonCategory: false,
  showInPlugin: false,
  autoPrices: true,
  categories: [{
    name: 'Suppléments / toppings',
    slug: 'extras',
    autoIdPrefix: 'supp',
    items: [{
      name: 'Passepoil',
      priceForAllTypes: 20,
      multiple: true
    }].concat(_toConsumableArray((0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_doss'
    })))
  }]
}, {
  name: 'Création de housse de canapé',
  slug: 'crea_cana',
  types: (0, _sofaCreation.getSofaTypes)(),
  subTypes: _sofaCreation.sofaSubTypes,
  autoId: true,
  hasMostCommonCategory: false,
  showInPlugin: false,
  autoPrices: true,
  categories: [{
    name: 'Suppléments / toppings',
    slug: 'extras',
    autoIdPrefix: 'supp',
    items: [{
      name: 'Liens accoudoirs (x2)',
      priceForAllTypes: 15,
      multiple: true
    }].concat(_toConsumableArray((0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_cana'
    })))
  }]
}, {
  name: 'Création de plaid/couvre-lit',
  slug: 'crea_plai',
  autoId: true,
  hasMostCommonCategory: false,
  showInPlugin: false,
  autoPrices: true,
  isSuitableForJunior: true,
  types: [{
    slug: 'SMALL',
    name: 'Petit (côté inférieur à < 99cm)'
  }, {
    slug: 'MEDIUM',
    name: 'Moyen (côté inférieur à < 199cm)'
  }, {
    slug: 'BIG',
    name: 'Grand (côté inférieur à < 300cm)'
  }],
  categories: [{
    name: 'Dimensions',
    slug: 'sizes',
    autoIdPrefix: 'dime',
    items: [{
      name: 'Petit < 99cm',
      prices: {
        SMALL: 33
      }
    }, {
      name: 'Moyen < 199cm',
      prices: {
        MEDIUM: 54
      }
    }, {
      name: 'Grand < 300cm',
      prices: {
        BIG: 75
      }
    }]
  }, {
    name: 'Suppléments / toppings',
    slug: 'extras',
    autoIdPrefix: 'supp',
    items: [{
      name: 'Doublure',
      prices: {
        SMALL: 5,
        MEDIUM: 12,
        BIG: 15
      }
    }, {
      name: 'Molleton fourni par le Tilliste',
      prices: {
        SMALL: 23,
        MEDIUM: 47,
        BIG: 76
      }
    }, {
      name: 'Molleton',
      prices: {
        SMALL: 13,
        MEDIUM: 17,
        BIG: 21
      }
    }].concat(_toConsumableArray((0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_plai'
    })))
  }]
}, {
  name: 'Création de housse de chaise',
  slug: 'crea_chai',
  autoId: true,
  hasMostCommonCategory: false,
  showInPlugin: false,
  autoPrices: true,
  isSuitableForJunior: true,
  types: [{
    slug: 'SMALL',
    name: 'Sans accoudoirs'
  }, {
    slug: 'BIG',
    name: 'Avec accoudoirs'
  }],
  categories: [{
    name: 'Accoudoirs',
    slug: 'armrests',
    autoIdPrefix: 'acco',
    items: [{
      name: 'Sans accoudoirs',
      prices: {
        SMALL: 34
      }
    }, {
      name: 'Avec accoudoirs',
      prices: {
        BIG: 64
      }
    }]
  }, {
    name: 'Suppléments / toppings',
    slug: 'extras',
    autoIdPrefix: 'supp',
    autoMultiple: true,
    items: [{
      name: 'Housse jupe longue',
      priceForAllTypes: 12,
      multiple: true
    }, {
      name: 'Liens accoudoirs (x2)',
      priceForAllTypes: 15,
      multiple: true
    }].concat(_toConsumableArray((0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_chai'
    })))
  }]
}, {
  name: 'Création de housse de tabouret/pouf',
  slug: 'crea_stoo',
  autoId: true,
  hasMostCommonCategory: false,
  showInPlugin: false,
  autoPrices: true,
  isSuitableForJunior: true,
  types: [{
    slug: 'SMALL',
    name: 'Petit (grand côté < 50cm)'
  }, {
    slug: 'BIG',
    name: 'Grand (grand côté > 50cm)'
  }],
  categories: [{
    name: 'Dimensions',
    slug: 'sizes',
    autoIdPrefix: 'dime',
    items: [{
      name: 'Petit (grand côté < 50cm)',
      prices: {
        SMALL: 26
      }
    }, {
      name: 'Grand (grand côté > 50cm)',
      prices: {
        BIG: 36
      }
    }]
  }, {
    name: 'Suppléments / toppings',
    slug: 'extras',
    autoIdPrefix: 'supp',
    autoMultiple: true,
    items: [{
      name: 'Liens accoudoirs (x2)',
      priceForAllTypes: 15,
      multiple: true
    }].concat(_toConsumableArray((0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_stoo'
    })))
  }]
}, {
  name: 'Création de rideaux',
  slug: 'crea_ride',
  hasMostCommonCategory: false,
  autoId: true,
  showInPlugin: false,
  isSuitableForJunior: true,
  types: [{
    slug: 'SIMPLE_SMALL',
    name: 'Un seul rideau - tringle < 140 cm'
  }, {
    slug: 'SIMPLE_MEDIUM',
    name: 'Un seul rideau - tringle < 200 cm'
  }, {
    slug: 'SIMPLE_BIG',
    name: 'Un seul rideau - tringle < 300 cm'
  }, {
    slug: 'SIMPLE_HUGE',
    name: 'Un seul rideau - tringle < 400 cm'
  }, {
    slug: 'COMPLEX_SMALL',
    name: 'Paire de rideaux - tringle < 140 cm'
  }, {
    slug: 'COMPLEX_MEDIUM',
    name: 'Paire de rideaux - tringle < 200 cm'
  }, {
    slug: 'COMPLEX_BIG',
    name: 'Paire de rideaux - tringle < 300 cm'
  }, {
    slug: 'COMPLEX_HUGE',
    name: 'Paire de rideaux - tringle < 400 cm'
  }],
  autoComplexFactor: 1,
  autoPrices: true,
  categories: [{
    name: 'Longueur rideau',
    slug: 'ride_length',
    autoIdPrefix: 'dime',
    items: [{
      name: 'Tringle < 140 cm',
      prices: {
        SIMPLE_SMALL: 50
      },
      autoComplexFactor: 1.4
    }, {
      name: 'Tringle < 200 cm',
      prices: {
        SIMPLE_MEDIUM: 80
      },
      autoComplexFactor: 1.25
    }, {
      name: 'Tringle < 300 cm',
      prices: {
        SIMPLE_BIG: 120
      },
      autoComplexFactor: 1.25
    }, {
      name: 'Tringle < 400 cm',
      prices: {
        SIMPLE_HUGE: 150
      },
      autoComplexFactor: 1.2
    }]
  }, {
    name: 'Hauteur rideau',
    slug: 'ride_height',
    autoIdPrefix: 'haut',
    items: [{
      name: 'Court (hauteur < à 200 cm)',
      prices: {
        SIMPLE_SMALL: 0,
        SIMPLE_MEDIUM: 0,
        SIMPLE_BIG: 0,
        SIMPLE_HUGE: 0
      }
    }, {
      name: 'Moyen (hauteur < à 300 cm)',
      prices: {
        SIMPLE_SMALL: 10,
        SIMPLE_MEDIUM: 20,
        SIMPLE_BIG: 30,
        SIMPLE_HUGE: 40
      }
    }, {
      name: 'Long (hauteur < à 400 cm)',
      prices: {
        SIMPLE_SMALL: 14,
        SIMPLE_MEDIUM: 28,
        SIMPLE_BIG: 42,
        SIMPLE_HUGE: 56
      }
    }]
  }, {
    name: 'Tête de rideau',
    slug: 'ride_head',
    autoIdPrefix: 'tete',
    items: [{
      name: 'Ruban passants cachés',
      prices: {
        SIMPLE_SMALL: 30,
        SIMPLE_MEDIUM: 30,
        SIMPLE_BIG: 37,
        SIMPLE_HUGE: 37
      }
    }, {
      name: 'Pattes apparentes',
      prices: {
        SIMPLE_SMALL: 56,
        SIMPLE_MEDIUM: 80,
        SIMPLE_BIG: 120,
        SIMPLE_HUGE: 160
      }
    }, {
      name: 'Galon fronceur',
      prices: {
        SIMPLE_SMALL: 30,
        SIMPLE_MEDIUM: 30,
        SIMPLE_BIG: 37,
        SIMPLE_HUGE: 37
      }
    }, {
      name: 'Nouettes',
      prices: {
        SIMPLE_SMALL: 56,
        SIMPLE_MEDIUM: 80,
        SIMPLE_BIG: 120,
        SIMPLE_HUGE: 160
      }
    }]
  }, {
    name: 'Suppléments / toppings',
    slug: 'extras',
    autoIdPrefix: 'supp',
    autoMultiple: true,
    items: [{
      name: 'Doublure',
      prices: {
        SIMPLE_SMALL: 20,
        SIMPLE_MEDIUM: 30,
        SIMPLE_BIG: 40,
        SIMPLE_HUGE: 50,
        COMPLEX_SMALL: 30,
        COMPLEX_MEDIUM: 40,
        COMPLEX_BIG: 50,
        COMPLEX_HUGE: 60
      }
    }, {
      name: 'Supplément fil de plomb',
      priceForAllTypes: 10,
      multiple: true
    }, {
      name: 'Dépose/pose d’un pan de rideau',
      priceForAllTypes: 10,
      multiple: true
    }].concat(_toConsumableArray((0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_ride',
      autoComplexFactor: 1
    })))
  }]
}, {
  name: 'Masque',
  slug: 'mask',
  hasMostCommonCategory: false,
  showInPlugin: false,
  types: undefined,
  categories: [{
    name: 'Fabrication',
    slug: 'fabrication',
    items: [{
      name: 'Masque en tissu',
      prices: {
        DEFAULT: 10
      },
      id: '9.mask-fab-1'
    }, {
      name: 'Masque en tissu adulte bleu avec lanières',
      prices: {
        DEFAULT: 10
      },
      id: '9.mask-fab-2'
    }, {
      name: 'Masque en tissu adulte beige avec lanières',
      prices: {
        DEFAULT: 10
      },
      id: '9.mask-fab-3'
    }, {
      name: 'Masque en tissu enfant bleu avec lanières',
      prices: {
        DEFAULT: 10
      },
      id: '9.mask-fab-4'
    }, {
      name: 'Masque en tissu enfant beige avec lanières',
      prices: {
        DEFAULT: 10
      },
      id: '9.mask-fab-5'
    }, {
      name: 'Masque en tissu adulte bleu avec élastiques',
      prices: {
        DEFAULT: 10
      },
      id: '9.mask-fab-6'
    }, {
      name: 'Masque en tissu adulte beige avec élastiques',
      prices: {
        DEFAULT: 10
      },
      id: '9.mask-fab-7'
    }, {
      name: 'Masque en tissu enfant bleu avec élastiques',
      prices: {
        DEFAULT: 10
      },
      id: '9.mask-fab-8'
    }, {
      name: 'Masque en tissu enfant beige avec élastiques',
      prices: {
        DEFAULT: 10
      },
      id: '9.mask-fab-9'
    }]
  }]
}];
var _default = exports["default"] = rawPricing;